import React from "react";
import _ from "lodash";
import UserAccessPoint from "MessagingV2/components/UserAccessPoint";
import UserAvatar from "./UserAvatar";

const UserAvatarWithAccessPoint = props => {
  const { user, fullName, avatarRenderMode, isBlocked, ...rest } = props;
  const userType = _.get(user, "type");

  return (
    <UserAccessPoint {...user} userType={userType} name={fullName} {...rest}>
      <UserAvatar
        user={user}
        fullName={fullName}
        avatarRenderMode={avatarRenderMode}
        isBlocked={isBlocked}
      />
    </UserAccessPoint>
  );
};

export default UserAvatarWithAccessPoint;
